import { FormBuilderService } from 'lib/ng2-sapmp/src/ui-components/form-builder/form-builder.service';
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';

import { ValidationService, AuthenticationService, AdobeAnalyticsService, UtilityService } from 'lib/ng2-sapmp/src/providers';
import { CartService } from './../../cart/cart.service'; // Need to move this logic in checkout service
import { UserProfileModel } from 'lib/ng2-sapmp/src/models';
import { CartModel, ProductConfigurationModel } from './../../../models';
import { StepIndicatorService } from 'lib/ng2-sapmp/src/ui-components/step-indicator';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { FormConfigurationModel, FormPropertyModel } from 'lib/ng2-sapmp/src/ui-components/form-builder';
import { RequestServiceConfiguration, RequestDcmCodes } from './shared';
import { TERMSANDCONDITIONS } from 'config';
declare var logoutCurrentUser: any;

@Component({
  selector: 'app-service-configuration',
  providers: [ValidationService, CartService, FormBuilderService],
  templateUrl: './service-configuration.component.html',
  styleUrls: ['./../checkout.component.scss']
})
export class ServiceConfigurationComponent implements OnInit, OnDestroy {

  user: UserProfileModel;
  errorMsg = '';
  cancelCheckout: boolean;

  cart: CartModel = null;
  productConfiguration: ProductConfigurationModel;
  requestServiceConfiguration: RequestServiceConfiguration;
  formConfiguration: FormConfigurationModel;
  formValid = true;
  formBuilderCheck = false;
  responseProductSpecifications: any;
  isCheckCartProductExist = false;
  prepopulateOtherForm: any;
  prepoulateFormGroup = new FormPropertyModel();
  accordionList: boolean[];
  dcmCodesTnc = {};
  errorMessage: string;
  termsConditionPopup: boolean;
  popupTitle: string;
  popupUrl: string;
  eventEmit: any;
  tncMap: Map<string, string>;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private utilityService: UtilityService,
    private stepindicatorService: StepIndicatorService,
    private authenticationService: AuthenticationService, private cartService: CartService,
    private pageloaderService: PageLoaderService,
    private formBuilderService: FormBuilderService,
    private adobeAnalyticsService: AdobeAnalyticsService) {
    this.user = new UserProfileModel();
    this.formBuilderCheck = false;
    this.formConfiguration = new FormConfigurationModel();
    this.formConfiguration.formProperty = [];
    this.formValid = false;
    this.productConfiguration = new ProductConfigurationModel();
    this.requestServiceConfiguration = new RequestServiceConfiguration();
    this.requestServiceConfiguration.dcmCodes = new RequestDcmCodes();
    this.requestServiceConfiguration.dcmCodes.dcmCodes = [];
    this.prepopulateOtherForm = undefined;
    this.accordionList = [];
    this.pageloaderService.setPageLoaderStatus(false);
    this.termsConditionPopup = false;
    this.popupTitle = undefined;
    this.popupUrl = undefined;
    this.eventEmit = undefined;
    this.tncMap = new Map<string, string>();
  }

  ngOnInit() {
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    this.authenticationService.setLoginSuccessUrl(this.router.routerState.snapshot.url);
    this.cart = JSON.parse(sessionStorage.getItem('cart'));

    if (this.cart === null) {
      this.router.navigate(['/home']);
      return;
    }

    this.user = this.authenticationService.getUser();
    this.stepindicatorService.setCurrentStep(this.activatedRoute.snapshot.url[0].path);
    this.stepindicatorService.setVisibility(true);
    this.isCheckCartProductExist = this.checkProductSpecificationExist();
    this.getProductDetails();
    this.cartService.createPageLoadProperties(this.cart, this.router.routerState.snapshot.url,
      'Checkout Step2 Service configuration', 'BC Checkout Step 2 Service Configuration Pg', 'Checkout');
  }

  getProductDetails() {
    this.cartService.getServiceProdDetails(this.requestServiceConfiguration.dcmCodes).subscribe(response => {
      this.responseProductSpecifications = response;
      this.responseProductSpecifications.forEach((value, index) => {
        value = this.mapTermsConditionsLink(value);
        this.formConfiguration.formProperty.push(new FormPropertyModel());
        if (index === 0) {
          this.accordionList.push(true);
        } else {
          this.accordionList.push(false);
        }
        const cartObject = this.cart.lineItems.find((data) => data.skuId === value.dcmCode);
        if (cartObject) {
          this.responseProductSpecifications[index].displayName = cartObject.displayName;
        }
      });
      if (this.isCheckCartProductExist) {
        this.responseProductSpecifications = this.updateFormInitialValue(this.responseProductSpecifications);
        this.formBuilderCheck = true;
        this.checkTermsConditionExist();
        this.checkProductSpecificationFormValid();
      } else {
        this.formBuilderCheck = true;
      }
      // this.checkFormsAvailable();
      this.pageloaderService.setPageLoaderStatus(true);
    }, error => {
      this.pageloaderService.setPageLoaderStatus(true);
      this.handleError(error);
    });
    this.formBuilderCheck = false;

  }

  mapTermsConditionsLink(product: any) {
    const removableIndex: Array<number> = [];
    const cartObject = this.cart.lineItems.find((data) => data.skuId === product.dcmCode);
    if (cartObject && cartObject.tncUrl) {
      this.tncMap.set(product.dcmCode, cartObject.tncUrl);
    }
    return product;
  }

  private getFormConfigDetails(formOutputvalue, rowIndex, dcmCode) {
    if (formOutputvalue.valid) {
      if (rowIndex === 0) {
        this.prepoulateFormGroup.formAttribute = formOutputvalue.value;
      }
      this.formConfiguration.formProperty[rowIndex].formAttribute = formOutputvalue.value;
      this.formConfiguration.formProperty[rowIndex].formStatus = true;
      this.updateCart(this.formConfiguration.formProperty[rowIndex].formAttribute, rowIndex);
      this.checkProductSpecificationFormValid();
    } else {
      this.formConfiguration.formProperty[rowIndex].formStatus = false;
      const cartIndex = this.getCartIndex(rowIndex);
      this.cart.lineItems[cartIndex].productConfigurations = [];
      this.checkProductSpecificationFormValid();
    }
  }

  private goToReviewOrder() {
    // this.cartService.createProductSpecificInfoCheckout(this.cart, 'SUCCESS', 'formSubmit');
    sessionStorage.setItem('cart', JSON.stringify(this.cart));
    this.router.navigate(['/checkout/reviewOrder'], { relativeTo: this.activatedRoute });
  }

  private updateCart(formPropertyDetail, rowIndex) {
    const getCartIndex = this.getCartIndex(rowIndex);
    this.cart.lineItems[getCartIndex].productConfigurations = [];
    this.cart.lineItems[getCartIndex].orderConfigurations = [];
    const tempObject = this.responseProductSpecifications.find(data => (data.dcmCode === this.cart.lineItems[getCartIndex].skuId));
    Object.keys(formPropertyDetail).forEach((key) => {
      for (const prodConf of tempObject.configurations) {
        if (prodConf.formControlName === key) {
          this.productConfiguration = new ProductConfigurationModel();
          this.productConfiguration.name = key;
          this.productConfiguration.value = formPropertyDetail[key];
          this.productConfiguration.label = prodConf.label;
          if (prodConf.elementType === 'dropdown') {
            this.productConfiguration.isDropDown = true;
          }
          if (prodConf.label === 'Terms & Conditions') {
            this.productConfiguration.show = false;
          }
          this.cart.lineItems[getCartIndex].productConfigurations.push(this.productConfiguration);
        }
      }
      for (const iterateOrderConfig of tempObject.configurations) {
        if (iterateOrderConfig.formControlName === key) {
          let orderConfig = Object.assign({}, iterateOrderConfig);
          if (iterateOrderConfig.elementType === 'dropdown') {
            orderConfig['initialValue'] = formPropertyDetail[key].value;
          } else {
            orderConfig['initialValue'] = formPropertyDetail[key];
          }
          delete orderConfig.fields;
          this.cart.lineItems[getCartIndex].orderConfigurations.push(orderConfig);
        }
      }
    });
  }

  private checkProductSpecificationFormValid() {
    for (const lineItem of this.cart.lineItems) {
      if (lineItem.productConfigurations.length > 0) {
        this.formValid = true;
      } else {
        this.formValid = false;
        break;
      }
    };
  }

  private checkProductSpecificationExist(): boolean {
    let isExist = false;
    this.cart.lineItems.forEach((lineItem, index) => {
      this.requestServiceConfiguration.dcmCodes.dcmCodes.push(lineItem.skuId);
      if (lineItem.productConfigurations.length > 0) {
        isExist = true;
      }
    });
    return isExist;
  }

  private updateFormInitialValue(resProductSpecifications): any {
    const responseProductSpecifications = resProductSpecifications;
    let responseIndex;
    let index = 0;
    for (const tempLineItem of this.cart.lineItems) {
      const getResponseProductSpecificationObject = resProductSpecifications.find(data =>
        (data.dcmCode === tempLineItem.skuId));
      responseIndex = resProductSpecifications.findIndex(data => (data === getResponseProductSpecificationObject));
      for (let lineItemProductConfig of tempLineItem.productConfigurations) {
        resProductSpecifications[responseIndex].configurations.forEach((value, subIndex) => {
          if (lineItemProductConfig.name === value.formControlName) {
            responseProductSpecifications[responseIndex].configurations[subIndex].initialValue
              = lineItemProductConfig.value;
            if (lineItemProductConfig.label === 'Terms & Conditions') {
              responseProductSpecifications[responseIndex].configurations[subIndex].initialValue = false;
            }
          }
        });
      }
      index++;
    }
    return responseProductSpecifications;
  }

  private goToBilling() {
    this.router.navigate(['/checkout/billing']);
  }

  private updateInputValues(value) {
    if (value) {
      this.formBuilderService.setForm(this.prepoulateFormGroup);
      this.cart.isApplySame = true;
    } else {
      this.cart.isApplySame = false;
    }
  }
  private openAccordion(rowIndex, arrayLength) {
    if (arrayLength === 1) {
      return;
    }

    for (let i = 0; i < this.accordionList.length; i++) {
      if (i === rowIndex) {
        this.accordionList[i] = !this.accordionList[i];
      }
    }
  }

  handleError = (error) => { // Arrow function is necessary as the context should be Parent class
    if (error) {
      if (error.status === 401) {
        this.errorMessage = 'Session expired.Please login again.';
        logoutCurrentUser(true);
      } else {
        this.errorMessage = 'We couldn\'t complete your request. Please try again later.';
      }
      this.adobeAnalyticsService.CreateSeriveAlertProperties(error.status, error.statusText, 'formResponse');
      this.utilityService.loadFocusOnTop();
    } else {
      throw error;
    }
  }

  private getCartIndex(rowIndex: number) {
    const cartIndex = this.cart.lineItems.findIndex(data => (data === this.cart.lineItems.find(cartData =>
      (cartData.skuId === this.responseProductSpecifications[rowIndex].dcmCode))));
    return cartIndex;
  }

  private checkTermsConditionExist() {
    let index = 0;
    for (const checkForTerms of this.responseProductSpecifications) {
      const cartIndex = this.getCartIndex(index);
      const tempCheck = checkForTerms.configurations.find((data) => data.label === 'Terms & Conditions');
      if (tempCheck) {
        this.cart.lineItems[cartIndex].productConfigurations = [];
        this.formConfiguration.formProperty[index].formStatus = false;
      } else {
        this.formConfiguration.formProperty[index].formStatus = true;
      }
      index++;
    };
  }

  private showTermsCondition(popupObject: any) {
    if (popupObject.isShow) {
      this.termsConditionPopup = true;
      this.popupTitle = popupObject.text;
      this.popupUrl = popupObject.url;
      this.eventEmit = popupObject.formEventEmitter;
    }
  }

  private redirectTermsCondition(dcmCode: any) {
    this.popupUrl = this.tncMap.get(dcmCode);
    if (this.popupUrl.length > 0) {
      window.open(this.popupUrl, '_blank');
    }
  }

  private checkFormsAvailable() {
    let productName = '';
    let isFormPropertyAvailableOrNot = [];
    isFormPropertyAvailableOrNot = this.responseProductSpecifications.filter((data) => (data.configurations.length === 0));
    if (isFormPropertyAvailableOrNot.length > 0) {
      isFormPropertyAvailableOrNot.forEach(value => {
        productName += (productName === '') ? value.displayName : ',' + value.displayName;
      });
      this.errorMessage = 'Product specification detail\'s are not available for ' + productName;
    }
  }

  ngOnDestroy() {
    this.pageloaderService.setPageLoaderStatus(true);
  }
}


